import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 800 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#007fff", d: "M0 0h800v600H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M36 120h84l26-84 26 84h84l-68 52 26 84-68-52-68 52 26-84-68-52zM750 0L0 450v150h50l750-450V0h-50", fill: "#f7d618" }), /* @__PURE__ */ React.createElement("path", { d: "M800 0L0 480v120l800-480V0", fill: "#ce1021" }));
const ForwardRef = forwardRef(SvgCd);
const Memo = memo(ForwardRef);
export default Memo;
